// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:47:20

export default {
  "id": "escape-or-die-troll-devil-levels",
  "slug": "escape-or-die-troll-devil-levels",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/a1be67ff60ef4d2eb604a44eb0307edc-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/a1be67ff60ef4d2eb604a44eb0307edc/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Escape or Die - Troll Devil Levels",
      "description": "Escape or Die: Troll Devil Levels, you’re thrust into a nightmarish world where trolls, twisted by ancient demonic curses, guard labyrinthine dungeons filled with deadly traps and unspeakable horrors. Your mission? Escape each level with devil alive— or end up as another soul devoured by the Troll Devil’s wrath. With ever-changing challenges and escalating danger, only the quickest, smartest, and bravest will survive.",
      "instructions": "Arrow keys or Touch Buttons",
      "genres": [
        "Adventure",
        "Agility"
      ],
      "tags": [
        "devil",
        "levels",
        "logic",
        "pixel"
      ]
    },
    "zh-CN": {
      "title": "逃离或死亡 - 巨魔恶魔关卡",
      "description": "逃亡或死亡：巨魔恶魔关卡，你被投放到一个噩梦般的世界中，那里由被古老恶魔诅咒扭曲的巨魔守卫着充满致命陷阱和难以言喻恐怖的迷宫地牢。你的任务？带着恶魔活着逃离每一关——否则将变成被巨魔恶魔怒火吞噬的另一个灵魂。随着挑战的不断变化和危险升级，只有最快、最聪明、最勇敢的人才能幸存。",
      "instructions": "方向键或触控按钮",
      "genres": [
        "冒险",
        "敏捷"
      ],
      "tags": [
        "恶魔",
        "关卡",
        "逻辑",
        "像素"
      ]
    },
    "zh-TW": {
      "title": "逃離或死亡 - 機關魔獸關卡",
      "description": "逃離或死亡：巨魔惡魔等級，你被推入一個惡夢般的世界，那裡的巨魔被古老的惡魔咒語扭曲，守護著充滿致命陷阱和不可言喻恐怖的迷宮地牢。你的任務是帶著惡魔存活逃離每個等級——否則就會成為另一個被巨魔惡魔怒火吞噬的靈魂。隨著挑戰不斷變化、危險不斷升級，只有最快、最聰明、最勇敢的人才能倖存。",
      "instructions": "方向鍵或觸控按鈕",
      "genres": [
        "冒險",
        "敏捷"
      ],
      "tags": [
        "惡魔",
        "等級",
        "邏輯",
        "像素"
      ]
    },
    "zh-HK": {
      "title": "逃亡或死亡 - 山丘精層級",
      "description": "逃亡或死亡：巨魔惡魔關卡，你被推入一個噩夢般的世界，其中被古老惡魔咒語扭曲的巨魔守護著充滿致命陷阱和不可言喻恐怖的迷宮地牢。你的任務是帶著惡魔存活逃離每個關卡——否則你將成為另一個被巨魔惡魔怒火吞噬的靈魂。隨著不斷變化的挑戰和升級的危險，只有最快、最聰明、最勇敢的人才能倖存。",
      "instructions": "方向鍵或觸控按鈕",
      "genres": [
        "冒險",
        "敏捷"
      ],
      "tags": [
        "惡魔",
        "關卡",
        "邏輯",
        "像素"
      ]
    },
    "ja": {
      "title": "脱出か死に - ツールデビルレベル",
      "description": "Escape or Die: Troll Devil レベルズ、あなたは古代の悪魔の呪いで歪んだトロルが守る、致命的な罠と形容難い恐怖で満ちた迷宮のダンジョンに突き込まれる悪夢の世界に放り込まれます。あなたのミッションは、どのレベルもデビルが生きているままに脱出することです。それができなければ、トロルデビルの怒りに飲まれるもう一つの魂になるだけです。変化する挑戦と増大する危険に直面して、最も素早く、賢く、勇敢な者だけが生き残ります。",
      "instructions": "アローキーまたはタッチボタン",
      "genres": [
        "アドベンチャー",
        "アギリティー"
      ],
      "tags": [
        "悪魔",
        "レベル",
        "論理",
        "ピクセル"
      ]
    },
    "ko": {
      "title": "탈출하거나 죽어라 - 트롤 디블 레벨",
      "description": "Escape or Die: Troll Devil Levels, 고대의 악마의 저주로 왜곡된 트롤들이 살인적인 장애물과 무서운 공포로 가득 찬 룬덤을 지키고 있는 괴梦中의 세계로 던져집니다. 당신의 임무는 각 레벨을 살아서 탈출하는 것입니다— 그렇지 않으면 트롤 디블의 분노로 썩은 또 다른 영혼이 됩니다. 변화하는 도전과 증가하는 위험 속에서, 가장 빠르고 지혜롭고 용감한 사람들만이 생존할 수 있습니다.",
      "instructions": "아로어 키 또는 타치 버튼",
      "genres": [
        "모험",
        "민첩성"
      ],
      "tags": [
        "달벨",
        "레벨",
        "로직",
        "픽셀"
      ]
    },
    "fr": {
      "title": "Échapper ou Mourir - Niveaux Troll Diabolique",
      "description": "Échappe-toi ou meurs : Niveaux Troll Démon, tu es plongé dans un monde cauchemardesque où des trolls, torturés par des malédictions démoniaques anciennes, gardent des donjons labyrinthiques remplis de pièges mortels et de terribles horreurs. Ta mission ? Échapper à chaque niveau avec le diable vivant — ou devenir une âme dévorée par la colère du Troll Démon. Avec des défis changeants et une dangerosité croissante, seuls les plus rapides, les plus intelligents et les plus courageux survivront.",
      "instructions": "Touches des flèches ou des boutons tactiles",
      "genres": [
        "Aventure",
        "Agilité"
      ],
      "tags": [
        "diable",
        "niveaux",
        "logique",
        "pixel"
      ]
    }
  }
};
